export default __webpack_public_path__ + "static/media/8_long.b75b22cc.svg";